import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewsContentSchema() {
  const { t } = useTranslation()

  return z.object({
    content: z.string().optional(),
    image: z
      .instanceof(File, { message: t('zod:errors.invalid_type') })
      .optional()
      .nullable(),
  })
}

export type NewsContentForm = z.infer<ReturnType<typeof NewsContentSchema>>
